import sport888SponsorIcon from "assets/img/icons/sponsors/sponsor_logo_888.svg";
import fanduelSponsorIcon from "assets/img/icons/sponsors/fanduel.svg";
import fanduelBlackSponsorIcon from "assets/img/icons/sponsors/fanduelBlue.svg";
import sportSponsorIcon from "assets/img/icons/sponsors/sponsor_logo_de.svg";
import sportSponsorIconDE from "assets/img/icons/sponsors/bWin.svg";
import snickersSponsorIcon from "assets/img/icons/sponsors/snickers.png";
import {SyndicatesType} from "data/enums";
import {SYNDICATE} from "data/constants";

export const HEADER_HEIGHT = 62;
export const MOBILE_HEADER_HEIGHT = 48;
export const DISABLE_SPORT_DE = true

export const sponsorLinks = {
	[SyndicatesType.US]:
		"https://super.walmart.com.mx/browse/promociones-especiales/mars/temporada-nfl/1940023_2880166_4220090",
	[SyndicatesType.AU]: "",
	[SyndicatesType.FR]: "",
	[SyndicatesType.DE]: DISABLE_SPORT_DE ? "" : "https://www.sport.de/genius-header/",
	[SyndicatesType.CA]: "",
	[SyndicatesType.BR]: "",
	[SyndicatesType.UK]: "https://www.888sport.com/",
};

export const sponsorLogos = {
	[SyndicatesType.US]: snickersSponsorIcon,
	[SyndicatesType.AU]: "",
	[SyndicatesType.FR]: "",
	[SyndicatesType.DE]: DISABLE_SPORT_DE ? sportSponsorIconDE : sportSponsorIcon,
	[SyndicatesType.CA]: fanduelSponsorIcon,
	[SyndicatesType.BR]: "",
	[SyndicatesType.UK]: sport888SponsorIcon,
};

export const modalSponsorLogos = {
	[SyndicatesType.US]: snickersSponsorIcon,
	[SyndicatesType.AU]: "",
	[SyndicatesType.FR]: "",
	[SyndicatesType.DE]: DISABLE_SPORT_DE ? "" : sportSponsorIcon,
	[SyndicatesType.CA]: fanduelBlackSponsorIcon,
	[SyndicatesType.BR]: "",
	[SyndicatesType.UK]: sport888SponsorIcon,
};

export const sponsorLogo = sponsorLogos[SYNDICATE];
export const sponsorLink = sponsorLinks[SYNDICATE];
export const modalSponsorLogo = modalSponsorLogos[SYNDICATE];

const pickemLinks = {
	[SyndicatesType.US]: "https://www.nflpickem.app/",
	[SyndicatesType.AU]: "https://nflpickem.com.au/",
	[SyndicatesType.FR]: "http://france.pickem.nfl.com/",
	[SyndicatesType.DE]: "http://nfltippspiel.sport.de/",
	[SyndicatesType.CA]: "https://canada.pickem.nfl.com/pick-em",
	[SyndicatesType.BR]: "",
	[SyndicatesType.UK]: "",
};

export const pickemLink = pickemLinks[SYNDICATE];
